import { colors } from '@/constants';
import styled from 'styled-components';
import { LuSearch } from 'react-icons/lu';
import { HiOutlineMicrophone } from 'react-icons/hi';
import { MdOutlinePhotoCamera } from 'react-icons/md';

interface PropsIcon {
  margintop?: number;
  marginleft?: number;
}

export const Search = styled(LuSearch)``;

export const OutlineMicrophone = styled(HiOutlineMicrophone)``;

export const SearchIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const EspecialSearchContent = styled.div<{ $isSpecialSearch: boolean }>`
  border-radius: 6px;
  padding: 4px;
  display: grid;
  place-items: center;
  background-color: ${(props) => (props.$isSpecialSearch ? colors.alert.green200 : colors.transparent)};
`;

export const SearchContent = styled.div`
  gap: 4px;
  display: flex;
  align-items: center;
`;

export const EspecialSearchText = styled.span`
  padding: 4px;
  font-size: 12px;
  font-weight: 400;
  display: grid;
  border-radius: 6px;
  place-items: center;
  color: ${colors.alert.green110};
  background-color: ${colors.alert.green200};
`;

export const OutlinePhotoCamera = styled(MdOutlinePhotoCamera)``;

export const Input = styled.input`
  &::placeholder {
    font-size: 14px;
  }
  width: 100%;
  border: none;
  outline: none;
`;

export const Icon = styled.img<PropsIcon>`
  margin-top: ${(props) => props.margintop || 0}px;
  margin-left: ${(props) => props.marginleft || 0}px;
`;

export const Button = styled.button`
  padding: 0px;
  border: none;
  display: grid;
  place-items: center;
  grid-auto-flow: column;
  background-color: ${colors.transparent};
`;

export const InputContent = styled.div<{ $backgroundColor?: string }>`
  gap: 10px;
  width: 100%;
  transition: all 0.4s;
  height: 44px;
  display: flex;
  background: ${(props) => props.$backgroundColor || colors.brand.white};
  border-radius: 4px;
  padding-left: 15px;
  padding-right: 15px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  input {
    background-color: transparent;
  }
`;
